import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CTAButton from '../ctaButton/CTAButton';
import { Section } from '../section/Section';

const AppIntentFallBackSection = ({ buttonText, url, queryParams }) => {
  const [missingParams, setMissingParams] = useState([]);
  const [link, setLink] = useState(`starlingbank://${url}`);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams();
    const missing = [];

    if (queryParams) {
      for (const key of queryParams) {
        const value = params.get(key);

        if (value) {
          newParams.set(key, value);
        } else {
          missing.push(key);
        }
      }
    }

    const protocol = window.starlingbank.getConfig('appIntentProtocol');
    const qs = newParams.toString();
    const querystring = qs.length ? `?${qs}` : '';
    const newLink = `${protocol}${url}${querystring}`;

    setMissingParams(missing);
    setLink(newLink);
  }, [queryParams, url]);

  return (
    <Section className="section-app-intent-fallback">
      {missingParams.length ? (
        <>
          <p>I'm sorry, that link is missing some required information.</p>
          <p>
            If the problem persists contact <a href="/contact/">Customer Service</a>.
          </p>
        </>
      ) : (
        <CTAButton text={buttonText || 'Go to Starling App'} link={link} />
      )}
    </Section>
  );
};

AppIntentFallBackSection.propTypes = {
  buttonText: PropTypes.string,
  url: PropTypes.string.isRequired,
  queryParams: PropTypes.arrayOf(PropTypes.string)
};

export default AppIntentFallBackSection;
